import { connect } from 'react-redux';
import { isSubmitting } from 'redux-form';
import Component from './Component';

import selectClientContacts from './Selectors/selectClientContacts';
import selectClientId from './Selectors/selectClientId';
import selectShowNewClientContactButton from './Selectors/selectShowNewClientContactButton';

import componentWillMount from './Handlers/componentWillMount';
import componentWillUnmount from './Handlers/componentWillUnmount';
import didCreateProject from './Handlers/didCreateProject';
import didCreateClientContact from './Handlers/didCreateClientContact';
import onClickCancel from './Handlers/onClickCancel';
import onClickSubmit from './Handlers/onClickSubmit';
import onChangeProject from './Handlers/onChangeProject';
import onClickNewProject from './Handlers/onClickNewProject';
import onClickNewClientContact from './Handlers/onClickNewClientContact';
import onCloseProjectModal from './Handlers/onCloseProjectModal';
import onCloseClientContactModal from './Handlers/onCloseClientContactModal';

import { FORM_NAME } from './Form';

const mapStateToProps = (state) => ({
  users: state.core.users,
  projects: state.core.projects,
  clientContacts: selectClientContacts(state),
  clientId: selectClientId(state),
  submitting: isSubmitting(FORM_NAME)(state),
  showNewClientContactButton: selectShowNewClientContactButton(state),
  showProjectModal: state.modals.Estimate.showProjectModal,
  showClientContactModal: state.modals.Estimate.showClientContactModal
});

const actionCreators = {
  componentWillMount,
  componentWillUnmount,
  didCreateProject,
  didCreateClientContact,
  onClickCancel,
  onClickSubmit,
  onChangeProject,
  onClickNewProject,
  onClickNewClientContact,
  onCloseProjectModal,
  onCloseClientContactModal
};

export default connect(mapStateToProps, actionCreators)(Component);